export default "__VITE_ASSET__yf9W2ZZ2__"